import React from 'react';
import propTypes from 'prop-types';
import { Typography } from '@saucelabs/ds-typography';

import Styles from './SectionTitle.styles';

export const SectionTitle = ({ children, headerLevel, subtitle = '' }) => (
  <hgroup className="mb-1">
    <Typography
      className={Styles['section-title']}
      disableSpacing
      variant={`heading-${headerLevel}`}
    >
      {children}
    </Typography>
    {subtitle && (
      <div className="mt-1 text-base text-gray-600">
        {subtitle}
      </div>
    )}
  </hgroup>
);

SectionTitle.propTypes = {
  children: propTypes.node.isRequired,
  headerLevel: propTypes.number,
  subtitle: propTypes.string,
};

SectionTitle.defaultProps = {
  headerLevel: 4,
  subtitle: null,
};
